import { render, staticRenderFns } from "./header-menu.vue?vue&type=template&id=5226c85a&scoped=true&lang=pug&"
import script from "./header-menu.vue?vue&type=script&lang=js&"
export * from "./header-menu.vue?vue&type=script&lang=js&"
import style0 from "./header-menu.vue?vue&type=style&index=0&id=5226c85a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5226c85a",
  null
  
)

export default component.exports